import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client";

import authLink from "../auth/authLink";

const cache = new InMemoryCache(
    {
        typePolicies: {
            Parameter: {
                fields: {
                    name: {
                        keyArgs: ["language"],
                    },
                },
            },
            Query: {
                fields: {
                    parameters: {
                        merge(existing = [], incoming) {
                            return [...existing, ...incoming];
                        },
                    },
                    parameter: {
                        read(existing, { args, toReference }) {
                            return existing ?? toReference({ __typename: "Parameter", id: args.id });
                        },
                    },
                },
            },
        },
    }
);

export default new ApolloClient(
    {
        cache,
        link: ApolloLink.from([authLink(), new HttpLink({ uri: "https://api.bimproject.cloud/graphql" })]),
    },
);
